// extracted by mini-css-extract-plugin
export default {"urlInput":"EmbedChunk-modules__urlInput__P4GJZ","youtubeWrapper":"EmbedChunk-modules__youtubeWrapper__q_WF6","youtubeFrame":"EmbedChunk-modules__youtubeFrame__xLfVx"};